import './styles.scss'

import I18n from 'lib/i18n'
import React from 'react'

export default function FavouritesHeader () {
  return (
    <div className='grid responsive-full-grid'>
      <div className='col-1-1'>
        <h1 className='page-title search-wish-list-title'>{I18n.t('layouts.application.favourites')}</h1>
      </div>
    </div>
  )
}
